import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import Button from '../../../../core/Button/Button.jsx';
import {joinTournament} from '../../../../redux/actions/tournament/actions.js';
import {addWaitingProcess} from "../../../../redux/actions/cash/actions.js";
import {calcAmount} from "../../../../utils/index.js";

function ProgressTournamentButton({row, desktopRequire = false}) {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const userId = useSelector((state) => state.user.id);
    const isMobile = useSelector((state) => state.user.isMobile);
    const list = useSelector((state) => state.tournament.list);
    const waitingProcesses = useSelector((state) => state.cash.waitingProcesses);
    const isWaiting = waitingProcesses.includes(row.table_tournament_id);

    const tournament = list[row.table_tournament_id] || {};
    const tournamentPlayers = tournament?.players || {};
    const tournamentPlayer = tournamentPlayers[userId] || {};
    const isPlayerPending = tournamentPlayer?.status === 'PENDING';
    const betAmount = calcAmount(tournament?.info, tournamentPlayer?.points,'EUR') || tournament?.info?.buyIn?.['EUR']
    const isReBuyActive = tournament?.info?.hasReBuy && tournament?.info?.round <= tournament?.info?.reBuyLimit

    if (!tournament?.info.registrationEnabled) return null;

    let buttonProps = {
        type: isReBuyActive ? 'green' : 'blue-border',
        text: isReBuyActive ? t(`tournament.reBuy`) : t(`tournament.started`),
        icon:  isReBuyActive ? 'icon-user-plus' : 'icon-information',
        cls: isReBuyActive && tournament?.info?.bettingTimer > -1 && tournament?.info?.bettingTimer <= 0 ? 'disabled-element' : '',
        isDisabled : isReBuyActive && tournament?.info?.bettingTimer > -1 && tournament?.info?.bettingTimer <= 0,
        action: () => {
            if (
                tournament?.info?.bettingTimer > -1 && tournament?.info?.bettingTimer <= 0 ||
                !isReBuyActive ||
                isWaiting ||
                isPlayerPending
            ) return;
            dispatch(addWaitingProcess({ process: tournament.id }));
            dispatch(joinTournament({ tournamentId: tournament.id, amount: betAmount }));
        },
    };

    if (isWaiting) {
        buttonProps = {
            type: 'blue-border',
            text: <i className='icon-spinner8 rotate'/>,
            icon:  'icon-spinner8 rotate',
            action: () => {}
        };

    } else if (['PENDING', 'PROGRESS'].includes(tournamentPlayers[userId]?.status)) {
        buttonProps = {
            type: 'red',
            text: t(`tournament.joined`),
            icon:  'icon-user-check',
            cls: 'disabled-element',
            isDisabled: true,
            action: () => {},
        };
    }


    // Button rendering logic
    const button = (
        <div className="button-size">
            <Button
                type={buttonProps?.type}
                onClick={buttonProps?.action}
                text={buttonProps?.text}
                cls={buttonProps?.cls}
                isDisabled={buttonProps?.isDisabled}
            />
        </div>
    );

    // Return appropriate rendering based on desktopRequire and isMobile
    if (desktopRequire) {
        return button;
    }

    return isMobile ? (
        <i className={buttonProps?.icon} onClick={(e) => {
            e.stopPropagation();
            buttonProps?.action()
        }}/>
    ) : (
        button
    );
}

export default ProgressTournamentButton;
